import { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { NAV_LINKS, COMPANY } from "@/lib/site-data";

export default function Header() {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 8);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="main-header"
            className={`sticky top-0 z-50 bg-white border-b border-[#CBD5E1] transition-shadow ${scrolled ? "shadow-[0_1px_0_#28406A]" : ""}`}
        >
            <div className="container-vl flex items-center justify-between gap-4 py-3 md:py-4">
                <Link to="/" data-testid="logo-link" className="flex items-center flex-shrink-0">
                    <img
                        src="/vibhuti-header-logo.jpg"
                        alt="Vibhuti Logistics"
                        className="h-9 sm:h-10 md:h-12 w-auto object-contain"
                    />
                </Link>

                <nav className="hidden lg:flex items-center gap-1" data-testid="primary-nav">
                    {NAV_LINKS.map((l) => (
                        <NavLink
                            key={l.href}
                            to={l.href}
                            data-testid={`nav-${l.label.toLowerCase()}`}
                            end={l.href === "/"}
                            className={({ isActive }) =>
                                `px-3 py-2 text-sm font-medium tracking-wide transition-colors ${
                                    isActive
                                        ? "text-[#28406A] border-b-2 border-[#F4A000]"
                                        : "text-[#4B6390] hover:text-[#28406A]"
                                }`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                </nav>

                <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0">
                    <a
                        href={`tel:${COMPANY.phones[0].replace(/\s/g, "")}`}
                        data-testid="header-phone"
                        className="hidden xl:inline-flex items-center gap-2 text-xs font-bold tracking-widest uppercase text-[#28406A] whitespace-nowrap"
                    >
                        <Phone className="h-4 w-4 flex-shrink-0" strokeWidth={1.75} />
                        {COMPANY.phones[0]}
                    </a>
                    <Link
                        to="/contact"
                        data-testid="header-cta-quote"
                        className="hidden sm:inline-flex items-center gap-2 bg-[#F4A000] text-[#101A2C] font-display uppercase font-semibold text-[10px] md:text-xs tracking-widest px-3 md:px-5 py-2.5 md:py-3 transition-transform hover:-translate-y-0.5 whitespace-nowrap"
                        style={{ boxShadow: "3px 3px 0px #101A2C" }}
                    >
                        Get Consultation
                    </Link>
                    <button
                        data-testid="mobile-menu-btn"
                        onClick={() => setOpen((v) => !v)}
                        className="lg:hidden p-2 text-[#28406A]"
                        aria-label="Toggle menu"
                    >
                        {open ? <X /> : <Menu />}
                    </button>
                </div>
            </div>

            {open && (
                <div className="lg:hidden border-t border-[#CBD5E1] bg-white" data-testid="mobile-nav">
                    <div className="container-vl py-4 flex flex-col">
                        {NAV_LINKS.map((l) => (
                            <NavLink
                                key={l.href}
                                to={l.href}
                                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                                onClick={() => setOpen(false)}
                                end={l.href === "/"}
                                className={({ isActive }) =>
                                    `py-3 border-b border-[#E9EEF3] text-sm font-medium uppercase tracking-wider ${
                                        isActive ? "text-[#28406A]" : "text-[#4B6390]"
                                    }`
                                }
                            >
                                {l.label}
                            </NavLink>
                        ))}
                    </div>
                </div>
            )}
        </header>
    );
}
